import React, { useState } from 'react';
import { Share2, Facebook, Twitter, Send, MessageSquare, Link2 } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const ShareButtons = ({ 
  title, 
  description, 
  url, 
  className = "",
  showText = true 
}) => {
  const [copied, setCopied] = useState(false);
  
  const siteUrl = 'https://cope.by';
  const currentUrl = url ? (url.startsWith('http') ? url : `${siteUrl}${url}`) : (typeof window !== 'undefined' ? window.location.href : '');
  const shareTitle = title || 'Психологическая консультация в Минске';
  const shareDescription = description || 'Профессиональная психологическая помощь в Минске';

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}&quote=${encodeURIComponent(shareTitle)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(`${shareTitle} - ${shareDescription}`)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(`${shareTitle} - ${shareDescription}`)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${shareTitle} - ${shareDescription} ${currentUrl}`)}`,
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      toast.success('Ссылка скопирована в буфер обмена!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Ошибка при копировании ссылки');
    }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareDescription,
          url: currentUrl,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.log('Error sharing:', err);
        }
      }
    } else {
      handleCopyLink();
    }
  };

  const handleShareClick = (platform) => {
    if (platform === 'copy') {
      handleCopyLink();
    } else {
      window.open(shareLinks[platform], '_blank', 'width=600,height=400');
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {showText && (
        <span className="text-sm text-olive-900/70 mr-2">Поделиться:</span>
      )}
      
      {/* Native Share для мобильных */}
      {navigator.share && (
        <Button
          variant="outline"
          size="sm"
          onClick={handleNativeShare}
          className="text-olive-700 border-olive-200 hover:bg-olive-50"
        >
          <Share2 className="w-4 h-4" />
          {showText && <span className="ml-2">Поделиться</span>}
        </Button>
      )}

      {/* Facebook */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleShareClick('facebook')}
        className="text-blue-600 border-blue-200 hover:bg-blue-50"
      >
        <Facebook className="w-4 h-4" />
        {showText && <span className="ml-2 hidden sm:inline">Facebook</span>}
      </Button>

      {/* Twitter */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleShareClick('twitter')}
        className="text-sky-600 border-sky-200 hover:bg-sky-50"
      >
        <Twitter className="w-4 h-4" />
        {showText && <span className="ml-2 hidden sm:inline">Twitter</span>}
      </Button>

      {/* Telegram */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleShareClick('telegram')}
        className="text-blue-500 border-blue-200 hover:bg-blue-50"
      >
        <Send className="w-4 h-4" />
        {showText && <span className="ml-2 hidden sm:inline">Telegram</span>}
      </Button>

      {/* WhatsApp */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleShareClick('whatsapp')}
        className="text-green-600 border-green-200 hover:bg-green-50"
      >
        <MessageSquare className="w-4 h-4" />
        {showText && <span className="ml-2 hidden sm:inline">WhatsApp</span>}
      </Button>

      {/* Копировать ссылку */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleShareClick('copy')}
        className={`${copied ? 'text-green-600 border-green-200 bg-green-50' : 'text-olive-700 border-olive-200 hover:bg-olive-50'}`}
      >
        <Link2 className="w-4 h-4" />
        {showText && (
          <span className="ml-2 hidden sm:inline">
            {copied ? 'Скопировано!' : 'Копировать'}
          </span>
        )}
      </Button>
    </div>
  );
};

export default ShareButtons;
